import {
	isFetchingMoreAtom,
	viewMoreFetchAtom,
} from '@components/reviews/atoms';
import {
	amountToRenderAtom,
	currentResultsCountAtom,
} from '@components/reviews/shared-atoms';
import type VendorAnalytics from '@decorators/vendorAnalytics';
import { useLiteStorefront } from '@hooks/use-lite-storefront';
import useAnalyticsContext from '@hooks/useAnalyticsContext';
import { CtaButton } from '@tkww/orion-web-ds-action';
import { Spinner } from '@tkww/orion-web-ds-feedback';
import { useAtomValue, useSetAtom } from 'jotai';
import React, { memo, useCallback, useMemo } from 'react';
import AnalyticsConstants from '../../../../../../../../constants/analytics';
import Styles from '../Reviews.scss';

interface Props {
	vendorAnalytics?: VendorAnalytics;
}
export const ViewMoreReviews = memo(({ vendorAnalytics }: Props) => {
	const isLiteStorefront = useLiteStorefront();
	const totalReviewsCount = useAtomValue(currentResultsCountAtom);
	const amountRendered = useAtomValue(amountToRenderAtom);
	const allReviewsShown = useMemo(() => {
		return amountRendered >= totalReviewsCount;
	}, [amountRendered, totalReviewsCount]);
	const isFetchingMore = useAtomValue(isFetchingMoreAtom);
	const fetchOrViewMore = useSetAtom(viewMoreFetchAtom);
	const { track } = useAnalyticsContext();

	const handleOnClick = useCallback(() => {
		track({
			event: AnalyticsConstants.SEE_MORE_REVIEWS,
			properties: vendorAnalytics?.baseEventProps() ?? {},
		});
		fetchOrViewMore();
	}, [track, vendorAnalytics, fetchOrViewMore]);

	if (allReviewsShown) {
		return null;
	}

	if (isFetchingMore) {
		return amountRendered <= 0 ? (
			<div className={Styles.loader} data-testid="view-more-loader" />
		) : (
			<Spinner />
		);
	}

	return (
		<CtaButton
			styleType="secondary"
			size="md"
			onClick={handleOnClick}
			{...(!isLiteStorefront && { block: 'xs' })}
		>
			View more
		</CtaButton>
	);
});
